import styled from 'styled-components';
export const PageContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${({ theme }) => theme.spacing(0, 4, 2, 4)};
`;
export default PageContainer;
